import { getDefaultStore } from 'jotai/vanilla';

import { initSentry } from '@cast/infrastructure-monitoring';

import { currentOrganizationSyncAtom } from '@cast/infrastructure-organization';
import { IS_PROD } from '@cast/constants';

initSentry({
  isProd: IS_PROD,
  getOrganization: () => getDefaultStore().get(currentOrganizationSyncAtom),
});
